import useNewsletterSignup from '../../Hooks/useNewsletterSignup/useNewsletterSignup';

const NewsletterSignupManager = () => {
  useNewsletterSignup();
  return null;
};

export default NewsletterSignupManager;
